import { useCallback, useMemo, useState } from 'react'
import { TextMatch } from 'shared/text'
import { ConventionResult, ConventionsSessionResult } from 'interface/convention'

type useConventionPageProps = {
  convention: ConventionResult | null
}
export const useConventionPage = ({
  convention
}: useConventionPageProps) => {
  const [searchWord, setSearchWord] = useState('')
  const [selectedKojinCode, setSelectedKojinCode] = useState<string | null>(null)
  const [selectedAuthorId, setSelectedAuthorId] = useState<number | null>(null)
  const [selectedSisetuCode, setSelectedSisetuCode] = useState<string | null>(null)

	const filteredSessionList = useMemo<ConventionsSessionResult[] | undefined>(() => {
    const textMatchInstance = new TextMatch(searchWord)
    return convention?.session?.filter(
      session =>
        textMatchInstance.match(session.sessionKey) ||
        textMatchInstance.match(session.sessionTitle) ||
        textMatchInstance.match(session.sponcer) ||
        textMatchInstance.match(session.abstract) ||
        session.speaker?.some(speaker => {
          textMatchInstance.match(speaker.kojinCode) ||
          textMatchInstance.match(speaker.role) ||
          textMatchInstance.match(speaker.speakerName) ||
          textMatchInstance.match(speaker.affiliationName) ||
          textMatchInstance.match(speaker.postName)
        })
    )
  }, [convention, searchWord])

  const onSelectKojin = useCallback(
		(kojinCode: string | null) => {
			setSelectedKojinCode(kojinCode)
			setSelectedAuthorId(null)
			setSelectedSisetuCode(null)
		},
		[setSelectedKojinCode, setSelectedAuthorId, setSelectedSisetuCode]
	)
  const onSelectAuthor = useCallback(
		(authorId: number | null) => {
			setSelectedKojinCode(null)
			setSelectedAuthorId(authorId)
			setSelectedSisetuCode(null)
		},
		[setSelectedKojinCode, setSelectedAuthorId, setSelectedSisetuCode]
	)
  const onSelectSisetu = useCallback(
		(sisetuCode: string | null) => {
			setSelectedKojinCode(null)
			setSelectedAuthorId(null)
			setSelectedSisetuCode(sisetuCode)
		},
		[setSelectedKojinCode, setSelectedAuthorId, setSelectedSisetuCode]
	)
  const closeModal = useCallback(
		() => {
			setSelectedKojinCode(null)
			setSelectedAuthorId(null)
			setSelectedSisetuCode(null)
		},
		[setSelectedKojinCode, setSelectedAuthorId, setSelectedSisetuCode]
	)

	return useMemo(() => ({
    searchWord,
    setSearchWord,
    filteredSessionList,
		selectedKojinCode, onSelectKojin,
		selectedAuthorId, onSelectAuthor,
		selectedSisetuCode, onSelectSisetu,
		closeModal
  }), [
    searchWord,
    setSearchWord,
    filteredSessionList,
		selectedKojinCode, onSelectKojin,
		selectedAuthorId, onSelectAuthor,
		selectedSisetuCode, onSelectSisetu,
		closeModal
	])
}
